import { i18n } from '@/locale';
import ctt from '@/utils/const';
import { merge } from 'lodash';

const xAxis = {
  type: 'time',
  axisTick: { show: false },
  splitLine: { show: false },
  axisLine: { lineStyle: { color: '#fff', opacity: 0.4 } }
};
const yAxis = {
  type: 'value',
  axisTick: { show: false },
  splitLine: { lineStyle: { color: '#fff', opacity: 0.2 } },
  axisLine: { lineStyle: { color: '#fff', opacity: 0.4 } },
  max(v) {
    // return v.max < 100 ? 2 * v.max : v.max + 100;

    if (v.max < 0) {
      return v.max / 2;
    }
    if (v.max == 0) {
      return v.max + 0.001;
    }
    return v.max < 100 ? 2 * v.max : v.max + 100;
  }
};
const textStyle = { color: '#00eeff80' };
const grid = { left: '4%', top: '18%', bottom: '20%', right: '5%', containLabel: true };
function initData() {
  return [];
}
export function legend(data = []) {
  return {
    top: 0,
    right: 0,
    data,
    itemWidth: 12,
    itemHeight: 12,
    textStyle: {
      color: '#00eeff',
      fontSize: 10
    }
  };
}
export function graColor(from, to) {
  return {
    type: 'linear',
    x: 0,
    y: 0,
    x2: 0,
    y2: 1,
    colorStops: [
      { offset: 0, color: from },
      { offset: 1, color: to }
    ]
  };
}

function echartObj(deviceType = ctt.FCBR_100PRO) {
  let deviceState = {
    tooltip: {
      formatter: '{b} <br/>{c} {a}',
      confine: true
    },
    series: [
      {
        name: 's',
        type: 'gauge',
        min: 0,
        max: 2.4,
        splitNumber: 6,
        radius: '70%',
        axisLine: {
          // 坐标轴线
          lineStyle: {
            // 属性lineStyle控制线条样式
            color: [
              [0.42, '#ff4500'],
              [0.6, 'lime'],
              [1, '#ff4500']
            ],
            width: 3,
            shadowColor: '#fff', // 默认透明
            shadowBlur: 5
          }
        },
        axisLabel: {
          // 坐标轴小标记
          textStyle: {
            // 属性lineStyle控制线条样式
            fontSize: 12,
            color: '#fff',
            shadowColor: '#fff', // 默认透明
            shadowBlur: 5
          }
        },
        splitLine: {
          // 分隔线
          length: 10, // 属性length控制线长
          lineStyle: {
            // 属性lineStyle（详见lineStyle）控制线条样式
            width: 3,
            color: '#fff',
            shadowColor: '#fff', // 默认透明
            shadowBlur: 5
          }
        },
        pointer: {
          width: 6,
          shadowColor: '#fff', // 默认透明
          shadowBlur: 5
        },
        title: {
          offsetCenter: ['0%', '100%'],
          textStyle: {
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            fontSize: 10,
            fontStyle: 'italic',
            color: '#fff',
            shadowColor: '#fff', // 默认透明
            shadowBlur: 5
          }
        },
        detail: {
          // backgroundColor: 'rgba(72, 156, 214, .2)',
          shadowBlur: 5,
          fontSize: 14,
          offsetCenter: [0, '70%'],
          textStyle: {
            fontWeight: 'bolder',
            color: '#00eeff'
          }
        },
        data: [
          {
            value: 0,
            name: '气流状态(L/min)'
          }
        ]
      },
      {
        name: '°C',
        type: 'gauge',
        center: ['20%', '50%'], // 默认全局居中
        radius: '56%',
        min: -20,
        max: 60,
        splitNumber: 4,
        axisLine: {
          // 坐标轴线
          lineStyle: {
            // 属性lineStyle控制线条样式
            color: [
              [0.5, '#1e90ff'],
              [0.8, 'lime'],
              [1, '#ff4500']
            ],
            width: 1,
            shadowColor: '#fff', // 默认透明
            shadowBlur: 5
          }
        },
        axisLabel: {
          // 坐标轴小标记
          textStyle: {
            // 属性lineStyle控制线条样式
            fontSize: 8,
            color: '#fff'
          }
        },
        axisTick: {
          // 坐标轴小标记
          length: 3, // 属性length控制线长
          lineStyle: {
            // 属性lineStyle控制线条样式
            color: 'auto',
            shadowColor: '#fff', // 默认透明
            shadowBlur: 5
          }
        },
        splitLine: {
          // 分隔线
          length: 5, // 属性length控制线长
          lineStyle: {
            // 属性lineStyle（详见lineStyle）控制线条样式
            width: 2,
            color: '#fff',
            shadowColor: '#fff', // 默认透明
            shadowBlur: 5
          }
        },
        pointer: {
          width: 5,
          shadowColor: '#fff', // 默认透明
          shadowBlur: 5
        },
        title: {
          offsetCenter: [0, '120%'], // x, y，单位px
          textStyle: {
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            fontSize: 10,
            fontStyle: 'italic',
            color: '#fff',
            shadowColor: '#fff', // 默认透明
            shadowBlur: 5
          }
        },
        detail: {
          shadowBlur: 5,
          fontSize: 13,
          offsetCenter: [0, '75%'],
          textStyle: {
            fontWeight: 'bolder',
            color: '#00eeff'
          }
        },
        data: [
          {
            value: 0,
            name: '温度(℃)'
          }
        ]
      },
      {
        name: '%',
        type: 'gauge',
        center: ['80%', '50%'], // 默认全局居中
        radius: '56%',
        min: 0,
        max: 100,
        startAngle: 135,
        endAngle: 45,
        splitNumber: 2,
        axisLine: {
          // 坐标轴线
          lineStyle: {
            // 属性lineStyle控制线条样式
            color: [[1, '#1e90ff']],
            width: 2,
            shadowColor: '#fff', // 默认透明
            shadowBlur: 5
          }
        },
        axisTick: {
          // 坐标轴小标记
          length: 3, // 属性length控制线长
          lineStyle: {
            // 属性lineStyle控制线条样式
            color: 'auto',
            shadowColor: '#fff', // 默认透明
            shadowBlur: 5
          }
        },
        axisLabel: {
          textStyle: {
            // 属性lineStyle控制线条样式
            fontSize: 8,
            color: '#fff',
            shadowColor: '#fff', // 默认透明
            shadowBlur: 5
          }
        },
        splitLine: {
          // 分隔线
          length: 5, // 属性length控制线长
          lineStyle: {
            // 属性lineStyle（详见lineStyle）控制线条样式
            width: 1,
            color: '#fff'
          }
        },
        pointer: {
          width: 2,
          shadowColor: '#fff', // 默认透明
          shadowBlur: 5
        },
        title: {
          offsetCenter: [0, '-120%'], // x, y，单位px
          textStyle: {
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            fontSize: 10,
            fontStyle: 'italic',
            color: '#fff',
            shadowColor: '#fff', // 默认透明
            shadowBlur: 5
          }
        },
        detail: {
          show: false
        },
        data: [
          {
            value: 0,
            name: '湿度(%RH)'
          }
        ]
      },
      {
        name: '故障',
        type: 'gauge',
        center: ['80%', '50%'], // 默认全局居中
        radius: '56%',
        min: 0,
        max: 2,
        startAngle: 315,
        endAngle: 225,
        splitNumber: 2,
        tooltip: {
          formatter: function (params) {
            switch (params.value + '') {
              case '0':
                return 'ht故障';
              case '1':
                return '正常';
              case '2':
                return '烟雾故障';
            }
          }
        },
        formatter: function (v) {
          switch (v + '') {
            case '0':
              return 'ht故障';
            case '1':
              return '正常';
            case '2':
              return '烟雾故障';
          }
        },
        axisLine: {
          // 坐标轴线
          lineStyle: {
            // 属性lineStyle控制线条样式
            color: [
              [0.2, '#ff4500'],
              [0.8, 'lime'],
              [1, '#ff4500']
            ],
            width: 2,
            shadowColor: '#fff', // 默认透明
            shadowBlur: 5
          }
        },
        axisTick: {
          // 坐标轴小标记
          show: false
        },
        axisLabel: {
          textStyle: {
            // 属性lineStyle控制线条样式
            fontSize: 8,
            color: '#fff',
            shadowColor: '#fff', // 默认透明
            shadowBlur: 5
          },
          formatter: function (v) {
            switch (v + '') {
              case '0':
                return '毒气';
              case '1':
                return '正常';
              case '2':
                return '烟雾';
            }
          }
        },
        splitLine: {
          // 分隔线
          length: 5, // 属性length控制线长
          lineStyle: {
            // 属性lineStyle（详见lineStyle）控制线条样式
            width: 1,
            color: '#fff',
            shadowColor: '#fff', // 默认透明
            shadowBlur: 5
          }
        },
        pointer: {
          width: 2,
          shadowColor: '#fff', // 默认透明
          shadowBlur: 5
        },
        title: {
          offsetCenter: ['0%', '120%'],
          textStyle: {
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            fontSize: 10,
            fontStyle: 'italic',
            color: '#fff',
            shadowColor: '#fff', // 默认透明
            shadowBlur: 5
          }
        },
        detail: {
          show: false
        },
        data: [
          {
            value: 1,
            name: '自检'
          }
        ]
      }
    ]
  };

  let smoke = {
    tooltip: {
      confine: true,
      formatter(params) {
        return `${params.data.name}: ${params.data.trueValue}<br/>状态: ${params.data.risk}`;
      }
    },
    series: {
      name: '烟雾浓度',
      type: 'gauge',
      title: { show: false },
      min: 0,
      max: 10,
      center: ['50%', '60%'],
      radius: '100%',
      startAngle: 180,
      endAngle: 0,
      splitNumber: 10,
      data: [{ value: 0, name: '约化浓度', risk: '正常', trueValue: 0 }],
      axisLine: {
        lineStyle: {
          color: [
            [0.2, '#a4c863'],
            [0.4, '#E4D836'],
            [0.6, '#E29035'],
            [0.8, '#E0643F'],
            [1, '#E0413F']
          ],
          width: 50
        }
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        formatter() {
          return '';
        },
        distance: 15,
        backgroundColor: '#fff',
        padding: 1.5,
        borderRadius: 1.5
      },
      splitLine: {
        length: 0
      },
      pointer: {
        width: 6
      },
      detail: {
        fontSize: 14,
        formatter: value => {
          switch (value) {
            case 1:
              return i18n.t('正常');
            case 3:
              return i18n.t('警告');
            case 5:
              return i18n.t('报警');
            case 7:
              return i18n.t('烟雾') + '1';
            case 9:
              return i18n.t('烟雾') + '2';
            default:
              return i18n.t('正常');
          }
        }
      }
    }
  };

  let bioBig = {
    textStyle,
    color: ['#9D66F1', '#03AFCE', '#0083ED'],
    tooltip: { trigger: 'axis', confine: true },
    legend: legend(['≥1μm 荧光', '≥1μm 颗粒']),
    grid,
    xAxis,
    yAxis: merge({}, yAxis, { name: '个/秒', minInterval: 1, boundaryGap: [0, 0.1] }),
    series: [
      { type: 'bar', barMaxWidth: 20, name: '≥1μm 荧光', data: initData() },
      { type: 'bar', barMaxWidth: 20, name: '≥1μm 颗粒', data: initData() }
    ]
  };
  let bioLittle = {
    textStyle,
    color: ['#9D66F1', '#03AFCE', '#0083ED'],
    tooltip: { trigger: 'axis', confine: true },
    legend: legend(['<1μm 荧光', '<1μm 颗粒']),
    grid,
    xAxis,
    yAxis: merge({}, yAxis, { name: '个/秒', minInterval: 1, boundaryGap: [0, 0.1] }),
    series: [
      { type: 'bar', barMaxWidth: 20, name: '<1μm 荧光', data: initData() },
      { type: 'bar', barMaxWidth: 20, name: '<1μm 颗粒', data: initData() }
    ]
  };

  let tvoc1 = {
    color: ['#03b36e'],
    textStyle,
    tooltip: { trigger: 'axis', confine: true },
    grid,
    xAxis,
    yAxis: merge({}, yAxis, { name: 'PPM', minInterval: 1, boundaryGap: [0, 0.1] }),
    series: {
      type: 'line',
      name: '有毒有害易燃气体指数',
      symbol: 'circle',
      symbolSize: 4,
      smooth: true,
      data: initData()
    }
  };
  let tvoc2 = {
    color: ['#487ec8', '#9D66F1', '#03AFCE'],
    textStyle,
    legend: legend(['氯气', '氨气', '一氧化碳']),
    tooltip: { trigger: 'axis', confine: true },
    grid,
    xAxis,
    yAxis: merge({}, yAxis, { name: 'PPM' }),
    series: [
      {
        type: 'line',
        name: '氯气',
        symbol: 'circle',
        symbolSize: 4,
        smooth: true,
        areaStyle: { color: graColor('rgba(72, 126, 200, 0.33)', 'rgba(72, 126, 200, 0.12)') },
        data: initData()
      },
      {
        type: 'line',
        name: '氨气',
        symbol: 'circle',
        symbolSize: 4,
        smooth: true,
        areaStyle: { color: graColor('rgba(157, 102, 241, 0.33)', 'rgba(157, 102, 241, 0.12)') },
        data: initData()
      },
      {
        type: 'line',
        name: '一氧化碳',
        symbol: 'circle',
        symbolSize: 4,
        smooth: true,
        areaStyle: { color: graColor('rgba(3, 175, 206, 0.33)', 'rgba(3, 175, 206, 0.12)') },
        data: initData()
      }
    ]
  };
  let tvoc3 = {
    color: ['#487ec8', '#9D66F1', '#03AFCE', '#e29035', '#03b36e'],
    textStyle,
    legend: legend(['氯化氢', '氨气', '二氧化硫', '一氧化碳', '甲烷']),
    tooltip: { trigger: 'axis', confine: true },
    grid,
    xAxis,
    yAxis: merge({}, yAxis, { name: 'PPM' }),
    series: [
      {
        type: 'line',
        name: '氯化氢',
        symbol: 'circle',
        symbolSize: 4,
        smooth: true,
        areaStyle: { color: graColor('rgba(72, 126, 200, 0.33)', 'rgba(72, 126, 200, 0.12)') },
        data: initData()
      },
      {
        type: 'line',
        name: '氨气',
        symbol: 'circle',
        symbolSize: 4,
        smooth: true,
        areaStyle: { color: graColor('rgba(157, 102, 241, 0.33)', 'rgba(157, 102, 241, 0.12)') },
        data: initData()
      },
      {
        type: 'line',
        name: '二氧化硫',
        symbol: 'circle',
        symbolSize: 4,
        smooth: true,
        areaStyle: { color: graColor('rgba(3, 175, 206, 0.33)', 'rgba(3, 175, 206, 0.12)') },
        data: initData()
      },
      {
        type: 'line',
        name: '一氧化碳',
        symbol: 'circle',
        symbolSize: 4,
        smooth: true,
        areaStyle: { color: graColor('rgba(226, 144, 53, 0.33)', 'rgba(226, 144, 53, 0.12)') },
        data: initData()
      },
      {
        type: 'line',
        name: '甲烷',
        symbol: 'circle',
        symbolSize: 4,
        smooth: true,
        areaStyle: { color: graColor('rgba(3, 179, 110, 0.33)', 'rgba(3, 179, 110, 0.12)') },
        data: initData()
      }
    ]
  };
  let tvoc4 = {
    color: ['#03b36e'],
    textStyle,
    tooltip: { trigger: 'axis', confine: true },
    legend: legend(['有毒有害易燃气体指数']),
    grid,
    xAxis,
    yAxis: merge({}, yAxis, { name: 'PPM', minInterval: 1, boundaryGap: [0, 0.1] }),
    series: {
      type: 'line',
      name: '有毒有害易燃气体指数',
      symbol: 'circle',
      symbolSize: 4,
      smooth: true,
      data: initData()
    }
  };

  let cwa = {
    color: ['#03AFCE', '#9D66F1'],
    textStyle,
    legend: legend(['正模式浓度', '负模式浓度']),
    tooltip: { trigger: 'axis', confine: true },
    grid,
    xAxis,
    yAxis: { ...yAxis, name: 'V' },
    series: [
      { type: 'line', name: '正模式浓度', symbol: 'circle', symbolSize: 4, data: initData() },
      { type: 'line', name: '负模式浓度', symbol: 'circle', symbolSize: 4, data: initData() }
    ]
  };

  let nuclear = {
    color: ['#03AFCE', '#7319e9', '#03b36e'],
    textStyle,
    legend: legend(['γ射线(μSv/h)', 'αβ射线(Bq/cm²)']),
    tooltip: { trigger: 'axis', confine: true },
    grid,
    xAxis,
    animation: true,
    yAxis: merge({}, yAxis),
    series: [
      {
        type: 'line',
        name: 'γ射线(μSv/h)',
        symbol: 'circle',
        symbolSize: 4,
        smooth: true,
        areaStyle: { color: graColor('rgba(3, 175, 206, 0.33)', 'rgba(3, 175, 206, 0.12)') },
        data: initData()
      },
      {
        type: 'line',
        name: 'αβ射线(Bq/cm²)',
        symbol: 'circle',
        symbolSize: 4,
        smooth: true,
        areaStyle: { color: graColor('rgba(115, 25, 233, 0.33)', 'rgba(115, 25, 233, 0.12)') },
        data: initData()
      }
    ]
  };

  let nuclear2 = {
    color: ['#03AFCE', '#7319e9', '#03b36e'],
    textStyle,
    legend: legend(['γ射线(μSv/h)', 'α射线(Bq/cm²)', 'β射线(Bq/cm²)']),
    tooltip: { trigger: 'axis', confine: true },
    grid,
    xAxis,
    animation: true,
    yAxis: merge({}, yAxis),
    series: [
      {
        type: 'line',
        name: 'γ射线(μSv/h)',
        symbol: 'circle',
        symbolSize: 4,
        smooth: true,
        areaStyle: { color: graColor('rgba(3, 175, 206, 0.33)', 'rgba(3, 175, 206, 0.12)') },
        data: initData()
      },
      {
        type: 'line',
        name: 'α射线(Bq/cm²)',
        symbol: 'circle',
        symbolSize: 4,
        smooth: true,
        areaStyle: { color: graColor('rgba(115, 25, 233, 0.33)', 'rgba(115, 25, 233, 0.12)') },
        data: initData()
      },
      {
        type: 'line',
        name: 'β射线(Bq/cm²)',
        symbol: 'circle',
        symbolSize: 4,
        smooth: true,
        areaStyle: { color: graColor('rgba(3, 179, 110, 0.33)', 'rgba(3, 179, 110, 0.12)') },
        data: initData()
      }
    ]
  };

  let gcamera = {
    color: ctt.CHART_COLOR,
    textStyle,
    legend: legend(['剂量率1', '剂量率2']),
    tooltip: { trigger: 'axis', confine: true },
    grid,
    xAxis,
    animation: true,
    yAxis: merge({ name: 'uSv/h' }, yAxis),
    series: [
      {
        type: 'line',
        name: '剂量率1',
        symbol: 'circle',
        symbolSize: 4,
        smooth: true,
        areaStyle: { color: graColor('rgba(3, 175, 206, 0.33)', 'rgba(3, 175, 206, 0.12)') },
        data: initData()
      },
      {
        type: 'line',
        name: '剂量率2',
        symbol: 'circle',
        symbolSize: 4,
        smooth: true,
        areaStyle: { color: graColor('rgba(115, 25, 233, 0.33)', 'rgba(115, 25, 233, 0.12)') },
        data: initData()
      }
    ]
  };
  let smokeAd = {
    color: ['#9D66F1'],
    textStyle,
    tooltip: { trigger: 'axis', confine: true },
    grid,
    xAxis,
    yAxis: merge({}, yAxis, { minInterval: 1, boundaryGap: [0, 0.1] }),
    series: {
      type: 'line',
      name: '烟雾',
      symbol: 'circle',
      symbolSize: 4,
      smooth: true,
      areaStyle: { color: graColor('rgba(157, 102, 241, 0.33)', 'rgba(157, 102, 241, 0.12)') },
      data: initData()
    }
  };

  // 电化学 TIC类别 单位PPM  二氧化氮 硫化氢
  const ecTIC = {
    color: ['#03AFCE', '#7319e9'],
    textStyle,
    legend: legend(['二氧化氮', '硫化氢']),
    tooltip: { trigger: 'axis', confine: true },
    grid,
    xAxis,
    animation: true,
    yAxis: merge({ name: 'PPM' }, yAxis),
    series: [
      {
        type: 'line',
        name: '二氧化氮',
        symbol: 'circle',
        symbolSize: 4,
        smooth: true,
        areaStyle: { color: graColor('rgba(3, 175, 206, 0.33)', 'rgba(3, 175, 206, 0.12)') },
        data: initData()
      },
      {
        type: 'line',
        name: '硫化氢',
        symbol: 'circle',
        symbolSize: 4,
        smooth: true,
        areaStyle: { color: graColor('rgba(115, 25, 233, 0.33)', 'rgba(115, 25, 233, 0.12)') },
        data: initData()
      }
    ]
  };

  // 电化学 ecCWA类别 单位PPM  氰化氢 光气
  const ecCWA = {
    color: ['#03AFCE', '#7319e9'],
    textStyle,
    legend: legend(['氰化氢', '光气']),
    tooltip: { trigger: 'axis', confine: true },
    grid,
    xAxis,
    animation: true,
    yAxis: merge({ name: 'PPM' }, yAxis),
    series: [
      {
        type: 'line',
        name: '氰化氢',
        symbol: 'circle',
        symbolSize: 4,
        smooth: true,
        areaStyle: { color: graColor('rgba(3, 175, 206, 0.33)', 'rgba(3, 175, 206, 0.12)') },
        data: initData()
      },
      {
        type: 'line',
        name: '光气',
        symbol: 'circle',
        symbolSize: 4,
        smooth: true,
        areaStyle: { color: graColor('rgba(115, 25, 233, 0.33)', 'rgba(115, 25, 233, 0.12)') },
        data: initData()
      }
    ]
  };

  // 氧
  const o2 = {
    color: ['#03AFCE', '#7319e9'],
    textStyle,
    legend: legend(['氧气']),
    tooltip: { trigger: 'axis', confine: true },
    grid,
    xAxis,
    animation: true,
    yAxis: merge({ name: 'vol%' }, yAxis),
    series: [
      {
        type: 'line',
        name: '氧气',
        symbol: 'circle',
        symbolSize: 4,
        smooth: true,
        areaStyle: { color: graColor('rgba(3, 175, 206, 0.33)', 'rgba(3, 175, 206, 0.12)') },
        data: initData()
      }
    ]
  };

  if ([ctt.FCBR_100CFR].includes(deviceType)) {
    return { deviceState, smoke, nuclear2, tvoc4, tvoc3, cwa };
  } else if ([ctt.FCBR_100PRO, ctt.FCBR_100PROGA].includes(deviceType)) {
    return { deviceState, smoke, bioBig, bioLittle, tvoc1, tvoc2, cwa, nuclear };
  } else if (
    [ctt.FCBR_100F, ctt.FCBR_100GA, ctt.FCBR_100_v1, ctt.FCBR_100_v2].includes(deviceType)
  ) {
    return { deviceState, smoke, bioBig, bioLittle, tvoc1, tvoc2, cwa, smokeAd };
  } else if (deviceType === ctt.FCBR_100G) {
    return { deviceState, smoke, bioBig, bioLittle, tvoc1, tvoc2, cwa, gcamera };
  } else if (deviceType === ctt.FCBR_100CP) {
    return { deviceState, smoke, tvoc1, tvoc2, cwa, gcamera, ecTIC, ecCWA, o2 };
  } else if (deviceType === ctt.FCBR_100C) {
    return { deviceState, smoke, tvoc1, tvoc2, cwa, smokeAd };
  } else if (deviceType === ctt.FCBR_100CV2) {
    return { deviceState, tvoc1, tvoc2, cwa };
  } else if (deviceType === ctt.FCBR_100B) {
    return { deviceState, smoke, bioBig, bioLittle, tvoc1, tvoc2 };
  }
}
export default echartObj;
